import type { IconPathData } from "@fortawesome/fontawesome-common-types"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon, type FontAwesomeIconProps } from "@fortawesome/vue-fontawesome"
import type { SVGAttributes } from "vue"
import { castUnsafe, type Component } from "vue-utils"

interface IconLookup {
	prefix: string
	iconName: string
}

export interface IconDefinition extends IconLookup {
	icon: [
		number, // width
		number, // height
		string[], // ligatures
		string, // unicode
		IconPathData, // svgPathData
	]
}

type Props = Omit<FontAwesomeIconProps, "icon"> & {
	icon: IconDefinition
}

const registeredIcons = new Set<string>()

const Icon: Component<Props, SVGAttributes> = (props) => {
	if (!registeredIcons.has(props.icon.iconName)) {
		registeredIcons.add(props.icon.iconName)
		library.add([castUnsafe(props.icon)])
	}

	return <FontAwesomeIcon {...props} />
}

export default Icon
